/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CenterModule } from '../components/CenterModule/CenterModule';
import {
  Container,
  TextField,
  Button,
  Typography,
  InputAdornment,
} from '@mui/material';
import UserIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import { api } from '../TokenManager';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();

    const normalizedUsername = String(username || '').trim();
    if (!normalizedUsername || !password) {
      alert('Enter username and password');
      return;
    }

    setIsSubmitting(true);
    try {
      await api.post('/api/login', {
        username: normalizedUsername,
        password,
      });

      // The backend stores the temporary pre-2FA token in an HttpOnly cookie.
      // React does not receive or store it.
      login({ isLoggedIn: true, is2FA: false, user: { email: normalizedUsername } });
      navigate('/2fa');
    } catch (error) {
      console.error('[Login] failed:', error);
      alert(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Invalid login credentials'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

/*
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box
        display="flex"
        flexDirection="column"
        gap={3}
        p={4}
        boxShadow={3}
        borderRadius={2}
      >
        <Typography variant="h5" align="center">
          {'Login'}
        </Typography>

        {(
          <>
            <TextField
              label="Username"
              type="username"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <UserIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Button variant="contained" onClick={handleLogin} fullWidth>
              Login
            </Button>
          </>
        )}
      </Box>
    </Container>
  );

*/

return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <CenterModule>
        <Typography variant="h5" align="center">
          {'Login'}
        </Typography>
        {(
          <>
            <TextField
              label="Username"
              type="username"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <UserIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Button variant="contained" onClick={handleLogin} fullWidth>
              Login
            </Button>
          </>
        )}
      </CenterModule>
    </Container>
  );
}



/*function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    // Mock login success without 2FA
    login({ isLoggedIn: true, is2FA: false });
    navigate('/2fa');
  };

  return (
    <div className="p-4">
      <h1 className="text-xl mb-4">Login</h1>
      <form onSubmit={handleLogin} className="space-y-4">
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="border p-2 w-full"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2 w-full"
          required
        />
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">Login</button>
      </form>
    </div>
  );
}*/

export default Login;